import { CircleAlert } from "lucide-react";
import React from "react";

const Status = ({ errorStatus, className }: any) => {
  return (
    <div className={`flex flex-col gap-2 items-center justify-center  w-full ${className}  `}>
      <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
      <h1 className={`text-[30px] font-semibold   ${errorStatus?.title === "warning" ? "text-yellow-500" : errorStatus?.title === "error" ? "text-red-500" : ""}`}>
        {errorStatus?.title === "info" ? "Infomation" : errorStatus?.title === "warning" ? "Warning" : "Error"}
      </h1>
      <span className=" text-muted-foreground text-md pt-3 ">{errorStatus?.message}</span>
    </div>
  );
};

export default Status;
